import {IRouletteBet} from "./IRouletteBet";

export class CornerBet implements IRouletteBet {
    constructor(public index: number, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/CornerBet.ts